(($, Drupal) => {
  Drupal.eu_cookie_compliance = Drupal.eu_cookie_compliance || ((...args) => {
    (Drupal.eu_cookie_compliance.queue = Drupal.eu_cookie_compliance.queue || []).push(args);
  });

  window.dataLayer = window.dataLayer || [];

  function gtag() {
    // eslint-disable-next-line
    dataLayer.push(arguments);
  }

  function getConsentStatus(parameter) {
    return Drupal.eu_cookie_compliance.hasAgreed(parameter) ? 'granted' : 'denied';
  }

  function postPreferencesHandler(mode) {
    return () => {
      gtag('consent', mode, {
        ad_storage: getConsentStatus('marknadsforing'),
        ad_personalization: getConsentStatus('marknadsforing'),
        ad_user_data: getConsentStatus('marknadsforing'),
        analytics_storage: getConsentStatus('analytic'),
        functionality_storage: getConsentStatus('functional'),
        personalization_storage: getConsentStatus('functional'),
        security_storage: getConsentStatus('functional'),
      });
    };
  }

  Drupal.behaviors.furubodaConsentMode = {
    attach: (context) => {
        setTimeout(() => {
        Drupal.eu_cookie_compliance('postPreferencesLoad', postPreferencesHandler('default'));
        Drupal.eu_cookie_compliance('postPreferencesSave', postPreferencesHandler('update'));
    }, 500);
    },
  };
 
})(jQuery, Drupal);